import { CriarCheckboxDeRastreaveis } from '../../../componentes/criarCheckboxDeRastreaveis';
import { AxiosConfig } from '../../../componentes/axiosConfig';


export class ExibirRastreaveisUsuarioCliente {
    constructor() {
        this._axios                  = (new AxiosConfig()).instanciaAxios();
        this._checkboxRastreaveis    = new CriarCheckboxDeRastreaveis();
        this._idDivExibirRastreaveis = 'containner-exibir-rastreaveis-tela-usuario-cliente';
        this._idCarregarRastreaveis  = 'carregar-rastreaveis-tela-usuario-cliente';
        this._idContainerUsuarios    = 'container-usuarios-cliente';
    }

    /**
     * @returns {void}
     */
    executar() {
        this._carregarRastreaveisQuandoSolicitado();
    }

    /**
     * Executado ao cadastrar ou atualizar um usuário do cliente.
     * Responsavel por exibir os rastreáveis associados ao cliente.
     *
     * @returns {void}
     */
    _carregarRastreaveisQuandoSolicitado() {
        const containerUsuarios = $(`#${this._idContainerUsuarios}`);
        if(containerUsuarios.length === 0){
            return;
        }

        containerUsuarios.on('click', `#${this._idCarregarRastreaveis}`, (evento) => {
            if($(`#${this._idCarregarRastreaveis}`).hasClass('activestate') === true) {
                return;
            }

            const formAtualizar = document.getElementById('form-usuarios-cliente-atualizar');
            const formCriarUsua = document.getElementById('form-usuarios-cliente-add');
            if (!formAtualizar && !formCriarUsua) {
                return;
            }

            const clienteId = this._obterIdCliente();
            if(clienteId && Number.isInteger(clienteId)) {
                const divExibirRastreaveis = document.getElementById(this._idDivExibirRastreaveis);
                this._checkboxRastreaveis
                .selecionarCheckbox(this._rastreaveisAssociadosAoUsuario())
                .criar(divExibirRastreaveis, [clienteId]);
            }
        });
    }

    /**
     * Obtem da url o id do cliente ao qual o usuário está associado.
     *
     * @returns {int}
     */
    _obterIdCliente() {
        const arrayPartesUrl = window.location.pathname.split('/');
        if (!Array.isArray(arrayPartesUrl) || arrayPartesUrl.length === 0){
            return undefined;
        }

        const clienteId = arrayPartesUrl[1] === 'clientes'
        ? parseInt(arrayPartesUrl[3])
        : undefined;

        return clienteId;
    }

    /**
     * No HTML deve existir uma div com a propriedade "data-rastreaveis-id", essa propriedade
     * recebe um array contendo os rastreáveis que o usuário tem acesso.
     *
     * @returns {int[]} um array contendo os id dos rastreáveis que o usuário tem acesso
     * @private
     */
    _rastreaveisAssociadosAoUsuario() {
        const rastreaveisDoUsuario = document.getElementById('rastreaveis-do-usuario');
        if (!rastreaveisDoUsuario || !rastreaveisDoUsuario.dataset.rastreaveisId) {
            return [];
        }

        let resposta = JSON.parse(rastreaveisDoUsuario.dataset.rastreaveisId);
        if (Array.isArray(resposta) && resposta.length > 0) {
            resposta = resposta.map((valorString) => {
                return parseInt(valorString);
            })
        }

        return Array.isArray(resposta) ? resposta : [];
    }
}
